import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Events, Platform, AlertController } from 'ionic-angular';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser'
import { MenuController } from 'ionic-angular';
import { Storagehelper } from '../../providers/storagehelper'
import { Commontask } from '../../providers/commontask'

declare var document;
import { Filetransfer } from '../../providers/filetransfer'
import { SocialSharing } from '@ionic-native/social-sharing';
/**
 * Generated class for the PageText page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
	selector: 'page-page-text',
	templateUrl: 'page-text.html',
})
export class PageText extends Commontask {

	@ViewChild('ioncontent') ioncontent: ElementRef;
	@ViewChild('detailPage') dataContainer: ElementRef;
	private pageid;
	private pageDetail;
	public bgImage;
	private loading;
	public removebckbutton;
	public bckclass;
 
	constructor(public navCtrl: NavController, public event: Events, public navParams: NavParams, public storage: Storagehelper, public loader: LoadingController, public menuctrl: MenuController, public sanitizer: DomSanitizer, public filetransfer: Filetransfer, public platform: Platform, public socialShare: SocialSharing, public alertCtrl: AlertController) {
		super(menuctrl, event, platform, socialShare, alertCtrl);
		this.pageDetail = { PageTitle: "", PageContent: "", bgImageUrl: "", localImageFile: "assets/images/c.png" };
		this.pageid = navParams.get('pageID');
		this.removebckbutton = navParams.get('removebckbutton');
		this.getPageDetail();
		this.loading = this.loader.create({
			spinner: "ios",
			cssClass: "dreamLoader"
		});
		this.bckclass = "";
		this.loading.present();
		this.bgImage = sanitizer.bypassSecurityTrustStyle('url(http://109.74.12.180/Dream/Uploads/Images/08253740996870014_backgroun`d_003(1).png)');
		this.getCategoryByCategoryID(storage, navParams);
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad PageText');
	}

	changeBackground() {

		console.log("changing background");
		var image = this.sanitizer.bypassSecurityTrustStyle('url(' + this.pageDetail.localImageFile + ')');
		return 'url(' + image + ')';
		// return { 'background-image': this.pageDetail.localImageFile };
	}

	getPageDetail() {

		this.storage.queryStorage('pagelist', 'Id', this.pageid).then((data) => {
			if (data.length > 0) {
				this.pageDetail = data[0];
				if (this.pageDetail.pagelinks.length > 0) {
					this.pageDetail.pagelinks.map((e, i) => {
						e.categoryid = this.navParams.get("categoryID");
					})
				}
				this.dataContainer.nativeElement.innerHTML = this.pageDetail.PageContent;

				if (this.pageDetail.backgroundType == 1) {
					if (this.pageDetail.bgImageUrl != "") {
						var localCheck = this.checkIfBackgroundStatic(this.pageDetail.bgImageUrl);
						if (localCheck != false) {
							this.loading.dismiss();
							// this.pageDetail.localImageFile=localurl;
							//Using javascript to set page background
							// document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length-1].style.backgroundImage="url('../assets/images/"+localCheck+".png')"
							this.bckclass = localCheck;
						} else {

							this.filetransfer.checkFileInLocal(this.pageDetail.bgImageUrl, "images").then((status) => {
								if (status == "false") {
									this.filetransfer.saveFileLocally(this.pageDetail.bgImageUrl, "images").then((localurl) => {
										this.loading.dismiss();
										this.pageDetail.localImageFile = localurl;
										//Using javascript to set page background
										document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundImage = "url('" + this.pageDetail.localImageFile + "')"

									}, (err) => {
										this.loading.dismiss();
										if (err == "browser") {

										}
									});
									this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
									document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundImage = "url('" + this.pageDetail.localImageFile + "')"
								} else {
									this.pageDetail.localImageFile = status;
									document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundImage = "url('" + this.pageDetail.localImageFile + "')"
								}
								this.loading.dismiss();
							}, (err) => {
								this.loading.dismiss();
								this.pageDetail.localImageFile = this.pageDetail.bgImageUrl;
								document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundImage = "url('" + this.pageDetail.localImageFile + "')"
							})
						}
					} else {

						this.loading.dismiss();
					}
				} else {
					this.loading.dismiss();
					document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundColor = "#" + this.pageDetail.backgroundColor;
					document.getElementsByClassName("pageion-content")[document.getElementsByClassName("pageion-content").length - 1].style.backgroundImage = "unset";
				}


			}
		})

	}

}



// WEBPACK FOOTER //
// ./src/pages/page-text/page-text.ts